import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=a711c2e8&"
import script from "./pdfViewer.vue?vue&type=script&lang=js&"
export * from "./pdfViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a711c2e8')) {
      api.createRecord('a711c2e8', component.options)
    } else {
      api.reload('a711c2e8', component.options)
    }
    module.hot.accept("./pdfViewer.vue?vue&type=template&id=a711c2e8&", function () {
      api.rerender('a711c2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/pdfViewer.vue"
export default component.exports